import angular from 'angular';
import customerCareInterestOnlyExpiry from './customerCareInterestOnlyExpiry';

export default angular
  .module('components.customerCareInterestOnlyExpiry', [])
  .component('customerCareInterestOnlyExpiry', customerCareInterestOnlyExpiry)
  .name;
